import { Box } from '@primer/react';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { hocSinhApi } from '../../api/hocSinhApi';
import Page from '../../components/ui/page';
import { ts_hocsinh_select_parent } from '../../models/request/hocsinh/ts_hocsinh_select_rq';
import { RootState } from '../../state/reducers';
import ThuPhiHocSinh from './ThuPhiHocSinh';
import ThuPhiTabs from './ThuPhiTabs';
import DanhSachHocSinhPage from '../thu-phi/danh-sach-hoc-sinh/DanhSachHocSinhPage';

const HOC_SINH_TAB_ID = "hoc-sinh";

const ThuPhiTabLayout = () => {
    const { selectedId } = useSelector((x: RootState) => x.thuPhiTab);
    const { nam_hoc, dm_coso_id } = useSelector((x: RootState) => x.common);
    const showDanhSachHocSinh = !selectedId || selectedId === HOC_SINH_TAB_ID;
    
    const [isLoading, setIsLoading] = useState(false);
    const [dataSourceFilter, setDataSourceFilter] = useState<any[]>([]);
    const [truongFilter, setTruongFilter] = useState(0);
    const [khoiFilter, setKhoiFilter] = useState(0);
    const [heFilter, setHeFilter] = useState(0);

    const handleReloadParents = useCallback(async () => {
        setIsLoading(true);
        const datasend: ts_hocsinh_select_parent = {
            nam_hoc: nam_hoc,
            dm_coso_id: dm_coso_id,
            dm_truong_id: truongFilter,
            dm_khoi_id: khoiFilter,
            dm_he_id: heFilter,
        };
        const res = await hocSinhApi.selectParentInformations(datasend);
        if (res.is_success) {
            setDataSourceFilter(res.data);
        }
        setIsLoading(false);
    }, [nam_hoc, dm_coso_id, truongFilter, khoiFilter, heFilter]);

    useEffect(() => {
        if (nam_hoc && dm_coso_id) {
            handleReloadParents();
        }
    }, [handleReloadParents, nam_hoc, dm_coso_id]);
    
    return (
        <Page title='Thu phí'>
            <Box>
                <ThuPhiTabs />
            </Box>
            <Box>
                {showDanhSachHocSinh ? (
                    <DanhSachHocSinhPage
                        dataSourceFilter={dataSourceFilter}
                        isLoading={isLoading}
                        onReload={handleReloadParents}
                        truongFilter={truongFilter}
                        khoiFilter={khoiFilter}
                        heFilter={heFilter}
                        onFilterChange={{ setTruongFilter, setKhoiFilter, setHeFilter }}
                    />
                ) : (
                    <ThuPhiHocSinh selectedTabId={selectedId} />
                )}
            </Box>

        </Page>
    );
};

export default ThuPhiTabLayout;